import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'semantic-ui-react';
import { isEmpty } from 'lodash';

export default class ShortTextFilterPanel extends React.Component {

  handleInput = (e, userInput) => {
    if(!userInput.value.trim()){
      this.props.removeSelection(this.props.question.id);
      return;
    }

    this.props.addSelection({
      questionId: this.props.question.id,
      type: this.props.question.type,
      value: userInput.value
    });
  };

  handleFormSubmit = (e) => {
    e.preventDefault();
    if (!this.props.onSubmit) {
      return;
    }
    this.props.onSubmit();
  };

  render() {
    return (
      <Form onSubmit={this.handleFormSubmit}>
        <Form.Input type="text"
                    value={isEmpty(this.props.value) ? '' : this.props.value}
                    onChange={this.handleInput} />
      </Form>
    )
  }
}

ShortTextFilterPanel.propTypes = {
  addSelection: PropTypes.func,
  removeSelection: PropTypes.func,
  onSubmit: PropTypes.func,
  question: PropTypes.shape({
    id: PropTypes.number.isRequired,
    type: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired
  }),
  value: PropTypes.string
}
